export default __webpack_public_path__ + "static/media/cloudy-icon.2cee75c6.png";